import React from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom'; 
import Container from 'react-bootstrap/Container';
import Navbar from "react-bootstrap/Navbar";
import NavbarBrand from "react-bootstrap/NavbarBrand";
import Nav from "react-bootstrap/Navbar";
import Footer from './components/Footer';
import HomePage from "./pages/HomePage";
import ContactPage from './pages/ContactPage';
import AboutPage from "./pages/AboutPage";
import SocialFollow from "./SocialFollow";

class App extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      title: 'Tafadzwa Munyuki',
      headerLinks: [
        {title: 'Home', path: '/'},  
        {title: 'About Me', path: '/about'},
        {title: 'Contact Me', path: '/contact'}
      ],
      home: {
        title: 'Robustness And Tenacity',
        subtitle: 'Engineered To Be A Full-Stack Engineer!',
        text: 'Projects Currently Available'
      },
      about:{
        title:'About Me'
      },
      contact:{
        title: 'Send Message'
      }
    }
  }
  render(){
    return (
      <Router>
       <Container className="p-0" fluid={true} >
        
        <Navbar className="border-bottom" bg="transparent" expand="lg">
          <Navbar.Brand>Tafadzwa Munyuki</Navbar.Brand>

          <img src="https://lh3.googleusercontent.com/ogw/ADGmqu8xS9B0jKU-D6jmLyKB2tpvoVFwaTdP7lQsUEgi=s32-c-mo" alt="Tafadzwa Munyuki" />

          <Navbar.Toggle className="border-0" aria-controls="navbar-toggle" />
          <Navbar.Collapse id="navbar-toggle">
            <Nav className="ml-auto">  {/* Float navbar to the right */}
              <Link className="nav-link" to="/">Home</Link>
              <Link className="nav-link" to="/about">About Me</Link>
              {/*<Link className="nav-link" to="/contact">Contact Me</Link> */} {/* Remove comment to display Contact Me Page */}

              
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        <Route path="/" exact render={()=> <HomePage title={this.state.home.title} subtitle={this.state.home.subtitle} text={this.state.home.text} />} />
        <Route path="/about" render={()=> <AboutPage title={this.state.about.title}  />} />
        <Route path="/contact" render={()=> <ContactPage title={this.state.contact.title}/>} />
        <Footer />


    </Container> 
      </Router>
      );
    }
  }


export default App;




